"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgShield = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24.447 34.894a1 1 0 01-.894 0 17.31 17.31 0 01-1.333-.765 22.465 22.465 0 01-2.879-2.126C16.646 29.643 15 26.969 15 24v-8a1 1 0 01.757-.97l8-2a1 1 0 01.486 0l8 2A1 1 0 0133 16v8c0 2.97-1.646 5.644-4.341 8.003a22.465 22.465 0 01-2.879 2.126 17.31 17.31 0 01-1.333.765zm.273-2.46a20.49 20.49 0 002.621-1.937C29.646 28.481 31 26.281 31 24v-7.22l-7-1.75-7 1.75V24c0 2.28 1.354 4.481 3.659 6.497A20.49 20.49 0 0024 32.863c.221-.126.463-.269.72-.43z",
    id: "shield_svg__a"
  }));
};

var _default = SvgShield;
exports.default = _default;